import React from 'react';
import { motion } from 'framer-motion';

const pieces = [
  { color: 'coral', x: -112, y: -54, rotate: 28 },
  { color: 'yellow', x: -64, y: -104, rotate: -18 },
  { color: 'sky', x: 12, y: -124, rotate: 42 },
  { color: 'orange', x: 82, y: -94, rotate: 12 },
  { color: 'coral', x: 124, y: -34, rotate: -36 },
  { color: 'yellow', x: 94, y: 34, rotate: 50 },
  { color: 'sky', x: -94, y: 22, rotate: -44 }
];

function Celebration() {
  return (
    <div className="celebration" aria-hidden="true">
      {pieces.map((piece, index) => (
        <motion.span
          key={`${piece.color}-${index}`}
          className={`confetti confetti--${piece.color}`}
          initial={{ x: 0, y: 0, scale: 0, opacity: 0 }}
          animate={{
            x: piece.x,
            y: piece.y,
            scale: [0, 1.2, 1],
            rotate: piece.rotate,
            opacity: [0, 1, 0.75]
          }}
          transition={{ delay: index * 0.05, duration: 0.75 }}
        />
      ))}
    </div>
  );
}

export default Celebration;